// extracted by mini-css-extract-plugin
export default {"container":"styles_container__NoIEr","content":"styles_content__91Qh8"};